module.exports = __webpack_public_path__ + "Group 15712.03beb3a6944d40baa73f.png";